export const QUEUE_COPY = {
  title: '佇列',
  folders: '資料夾',
  filterIntent: '意圖',
  filterKind: '類型',
  filterSource: '判定來源',
  filterAuthor: '作者',
  filterAll: '全部',
  empty: { inbox: '收件匣已清空', spam: '垃圾資料夾是空的', muted: '沒有收合的項目' },
  emptyBody: '有新的留言或私訊時會出現在這裡。',
  loading: '載入佇列…',
  loadFailed: '載入佇列失敗',
  retry: '重新載入',
  itemList: '佇列項目',
  pagination: '分頁',
  previousPage: '上一頁',
  nextPage: '下一頁',
  pageStatus: (page: number, total: number, limit: number) =>
    `第 ${page} 頁，共 ${Math.max(1, Math.ceil(total / limit))} 頁（${total} 個項目）`,
  unclassified: 'AI 無法分類',
  confidence: (value: string) => `信心值 ${value}`,
  claimedByOther: (name: string) => `${name} 處理中`,
  claimedByMe: '我處理中',
  viewedByOther: (name: string) => `${name} 正在看`,
  unreadCount: (count: number) => `，${count} 則未讀訊息`,
  notYetViewed: '，尚未有人查看',
  openItem: (author: string, preview: string) => `開啟 ${author} 的項目：${preview}`,
} as const
